import { render } from "./LoginPage.vue?vue&type=template&id=51852762&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=51852762&scoped=true&lang=scss"

import exportComponent from "/home/aix/www/prod/community_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51852762"]])

export default __exports__